// extracted by mini-css-extract-plugin
export var editButton = "_or-0";